module.exports = __webpack_public_path__ + "dashboard/img/down_down.12462b95dc38c6131979a8bc9e34122a.svg";